import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import '@oneblink/apps-react/dist/styles.css'
import { AuthContextProvider } from '@oneblink/apps-react'
import { ToastContainer, Slide } from 'react-toastify'

import FormDefinitionsProvider from './providers/FormDefinitionsProvider'
import ThemeProvider from './providers/ThemeProvider'
import HeaderButtonsProvider from './providers/HeaderButtonsProvider'
import AppConfigProvider from './providers/AppConfigProvider'
import HelpMessageProvider from './providers/HelpMessageProvider'
import SystemMaintanceProvider from './providers/SystemMaintenanceProvider'

import FormContainer from './scenes/Form/FormContainer'
import FormReceipt from './scenes/Form/ReceiptPages/Receipt'
import ActivityReportDraftReceipt from './scenes/Form/ReceiptPages/ActivityReportDraftReceipt'
import FormsList from './scenes/FormsList/FormsList'
import ResumeDraft from './scenes/Drafts/ResumeDraft'
import DraftReceipt from './scenes/Drafts/DraftReceipt'
import Logout from './scenes/Auth/Logout'
import ProfileScene from './scenes/Profile'

import GoogleAnalytics from './components/GoogleAnalytics'
import OAuthCallback from './components/Auth/OAuthCallback'
import AuthHOC from './components/Auth/AuthCheck'
import ScrollToTop from './components/ScrollToTop'
import { FlexContainer } from './components/LayoutComponents'
import Page from './components/Page'

function App() {
  return (
    <FlexContainer>
      <ThemeProvider>
        <SystemMaintanceProvider>
          <AppConfigProvider>
            <GoogleAnalytics />
            <AuthHOC>
              <AuthContextProvider>
                <HeaderButtonsProvider>
                  <HelpMessageProvider>
                    <Router>
                      <Page>
                        <ScrollToTop>
                          <Switch>
                            <Route path="/callback">
                              <OAuthCallback />
                            </Route>
                            <Route path="/logout">
                              <Logout />
                            </Route>
                            <Route path="/me">
                              <ProfileScene />
                            </Route>
                            <FormDefinitionsProvider>
                              <Route path="/" exact>
                                <FormsList />
                              </Route>
                              <Route path="/forms/:formId/receipt">
                                <FormReceipt />
                              </Route>
                              <Route path="/forms/:formId" exact>
                                <FormContainer />
                              </Route>
                              <Route path="/resume-draft">
                                <ResumeDraft />
                              </Route>
                              <Route path="/draft/:trackingCode">
                                <DraftReceipt />
                              </Route>
                              <Route path="/activity-report/draft">
                                <ActivityReportDraftReceipt />
                              </Route>
                            </FormDefinitionsProvider>
                          </Switch>
                        </ScrollToTop>
                      </Page>
                    </Router>
                  </HelpMessageProvider>
                </HeaderButtonsProvider>
              </AuthContextProvider>
            </AuthHOC>
          </AppConfigProvider>
        </SystemMaintanceProvider>
        <ToastContainer transition={Slide} closeOnClick />
      </ThemeProvider>
    </FlexContainer>
  )
}

export default App
